import { CountResponse } from '@interfaces/common.interface';
import {
  CountSearchAnalyticsRequestParams,
  GetSearchAnalyticsRequestParams,
  GetSearchAnalyticsXlsxQueryParams,
  ProductSearchEvent,
  SearchAnalyticsStatsResponse,
} from '@interfaces/searchAnalytics.interface';

import api from './';

function omitEmptyParams<T extends object>(params: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  ) as Partial<T>;
}

export const {
  useCountSearchAnalyticsQuery,
  useGetSearchAnalyticsQuery,
  useGetSearchAnalyticsStatsQuery,
  useLazyGetSearchAnalyticsXlsxQuery,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    countSearchAnalytics: builder.query<
      CountResponse,
      CountSearchAnalyticsRequestParams
    >({
      query: (params) => ({
        url: 'search-analytics/count',
        params: omitEmptyParams(params),
      }),
      providesTags: ['search-analytics'],
    }),
    getSearchAnalytics: builder.query<
      ProductSearchEvent[],
      GetSearchAnalyticsRequestParams
    >({
      query: (params) => ({
        url: 'search-analytics',
        params: omitEmptyParams(params),
      }),
      providesTags: ['search-analytics'],
    }),
    getSearchAnalyticsStats: builder.query<SearchAnalyticsStatsResponse, void>({
      query: () => ({
        url: 'search-analytics/stats',
      }),
      providesTags: ['search-analytics'],
    }),
    getSearchAnalyticsXlsx: builder.query<
      Blob,
      GetSearchAnalyticsXlsxQueryParams
    >({
      query: (params) => ({
        url: 'search-analytics/xlsx',
        params: omitEmptyParams(params),
        responseHandler: async (response) => await response.blob(),
        cache: 'no-cache',
      }),
    }),
  }),
});
